import React from 'react';

class Spinner extends React.PureComponent {
  render() {
    return (
      <div id="spinnerWrapper">
        <div id="spinner"></div>
      </div>
    );
  }
}

export default Spinner;
